import mobiuspackWhiteLogo from '../../assets/logos/mobiuspack-white-logo.svg';

// Brand MOBIUSpack par défaut (utilisée quand aucun parcelId fourni)
export const MOBIUSPACK_DEFAULT_BRAND = {
  brand: 'mobiuspack',
  brandName: 'MOBIUSpack',
  brandColor: '#2EA9C7',
  brandGradient: 'linear-gradient(150deg, #2EA9C7 0%, #1B2E28 100%)',
  brandTextColor: '#FFFFFF',
  brandLogoUrl: mobiuspackWhiteLogo,
  heroImageUrl: null,
  daysLeft: 14,
  maxDays: 14,
  impact: { co2Saved: '85%', waterSaved: '63%' },
};

export const DEFAULT_INFO = {
    daysLeft: 12,
    maxDays: 14,
    impact: { co2Saved: '87%', waterSaved: '64%' }
};


